export const iconOptions = [
  "fas fa-users",
  "fas fa-user",
  "fas fa-user-circle",
  "fas fa-user-plus",
  "fas fa-user-edit",
  "fas fa-home",
  "fas fa-building",
  "fas fa-city",
  "fas fa-cog",
  "fas fa-tools",
  "fas fa-wrench",
  "fas fa-chart-bar",
  "fas fa-chart-line",
  "fas fa-chart-pie",
  "fas fa-envelope",
  "fas fa-inbox",
  "fas fa-paper-plane",
  "fas fa-bell",
  "fas fa-bell-slash",
  "fas fa-file",
  "fas fa-file-alt",
  "fas fa-file-invoice",
  "fas fa-folder",
  "fas fa-folder-open",
  "fas fa-list",
  "fas fa-list-alt",
  "fas fa-th",
  "fas fa-th-large",
  "fas fa-th-list",
  "fas fa-database",
  "fas fa-server",
  "fas fa-lock",
  "fas fa-unlock",
  "fas fa-key",
  "fas fa-shield-alt",
  "fas fa-shopping-cart",
  "fas fa-store",
  "fas fa-credit-card",
  "fas fa-wallet",
  "fas fa-calendar",
  "fas fa-calendar-alt",
  "fas fa-clock",
  "fas fa-image",
  "fas fa-camera",
  "fas fa-map",
  "fas fa-map-marker-alt",
  "fas fa-globe",
  "fas fa-link",
  "fas fa-edit",
  "fas fa-trash",
];